var moduleMap = {
	"./analytics": () => {
		return Promise.all([__webpack_require__.e(4446), __webpack_require__.e(2291), __webpack_require__.e(6483), __webpack_require__.e(1630), __webpack_require__.e(5849), __webpack_require__.e(2926), __webpack_require__.e(7035), __webpack_require__.e(997), __webpack_require__.e(8224), __webpack_require__.e(469), __webpack_require__.e(8186), __webpack_require__.e(3322), __webpack_require__.e(8312), __webpack_require__.e(3076), __webpack_require__.e(40), __webpack_require__.e(5566), __webpack_require__.e(1175), __webpack_require__.e(5336), __webpack_require__.e(3778), __webpack_require__.e(1346), __webpack_require__.e(9466), __webpack_require__.e(9258), __webpack_require__.e(7450), __webpack_require__.e(1472), __webpack_require__.e(3050), __webpack_require__.e(890), __webpack_require__.e(3016), __webpack_require__.e(9336), __webpack_require__.e(9905), __webpack_require__.e(5429), __webpack_require__.e(4078), __webpack_require__.e(489), __webpack_require__.e(689), __webpack_require__.e(6858)]).then(() => (() => ((__webpack_require__(66858)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});